import { Injectable, inject } from '@angular/core';

import { GoogleAnalyticsCoreService, OnFeatureInit } from '@frontend/vanilla/core';
import { firstValueFrom } from 'rxjs';

import { GoogleAnalyticsConfig } from './google-analytics.client-config';
import { GoogleAnalyticsService } from './google-analytics.service';

@Injectable()
export class GoogleAnalyticsBootstrapService implements OnFeatureInit {
    private readonly config = inject(GoogleAnalyticsConfig);
    private readonly googleAnalyticsService = inject(GoogleAnalyticsService);
    private readonly googleAnalyticsCoreService = inject(GoogleAnalyticsCoreService);

    async onFeatureInit() {
        await firstValueFrom(this.config.whenReady);

        this.googleAnalyticsCoreService.set(this.googleAnalyticsService);
    }
}
